import classNames from 'classnames';
import React from 'react';
import { Checkbox } from '@udemy/react-form-components';
import { Loader } from '@udemy/react-reveal-components';
import styles from "./checkbox-with-loader.module.css";
export const CheckboxWithLoader = ({
  isLoading = false,
  children,
  ...givenProps
}) => {
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('ud-text-sm', styles['loader-state'])
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "xsmall",
      className: styles['loader-icon']
    }), children);
  }
  return /*#__PURE__*/React.createElement(Checkbox, givenProps, children);
};
//# sourceMappingURL=checkbox-with-loader.react-component.js.map